const category = {
  'pages.platform.user.staff.name': 'Staff Name',
}

export default category
